<template>
  <BreadCrumb PageTitle="Modifier Colis" />
  <EditColis :id="id" :code="code" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditColis from "../../components/Colis/EditColis.vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditColisPage",
  components: {
    BreadCrumb,
    EditColis,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id;  // <-- get the id
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }


    let code = route.params.code;  // <-- get the code
    if (Array.isArray(code)) {
      code = code[0] ?? "";
    }


    return { id, code }
  },
});
</script>